import NavbarVixo from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import WhyVixo from "./components/WhyVixo";
import Contact from "./components/Contact";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Portfolio from "./components/Portfolio";
function App() {
  return (
    <>
      <NavbarVixo />
      <Hero />
      <Services />
      <WhyVixo />
      <Contact />
    
      <Portfolio />
    </>
  );
}


export default App;
